import * as React from "react";
import { Modal, Button } from 'antd';

const ModalExport = ({showModal, visible, handleOk, confirmLoading, handleCancel, person}) => (
    <div>
        <Button type="primary" onClick={showModal}>Export to excel</Button>
        <Modal title={"Export " + person.firstName + " " + person.lastName}
               visible={visible}
               onOk={handleOk}
               confirmLoading={confirmLoading}
               onCancel={handleCancel}
        >
            <p>We urge you to remember that this is data on real persons and that these persons have rights as
                data subjects.
            </p>
            <p>Data extracted is deemed outdated 3 months after date of extraction and must then be deleted in
                all versions.
            </p>
            <br/>
            <p>Our native speaking data teams are ready to assist you – get in touch today and get the most out
                of the high quality data.
            </p>
            <p>Thank you</p>
            <br/>
            <br/>
            <br/>
        </Modal>
    </div>
)



export default ModalExport


// WEBPACK FOOTER //
// ./src/js/browse/person/Modal.js